import { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { SelectDropdown } from '@/schemas/sceneDataSchema';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';
import { useFieldBinding, seedFormFromStore } from '@/hooks/use-field-binding';
import { BaseSelectDropdown } from './BaseSelectDropdown';

export const SelectDropdownFormElement = ({ form, component }: { form: UseFormReturn; component: SelectDropdown }) => {
  const fieldName = encodeFieldKey(component);
  const binding = useFieldBinding(component, form);

  useEffect(() => {
    seedFormFromStore(form, fieldName, binding.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Controller
      control={form.control}
      name={fieldName}
      render={({ field, fieldState }) => (
        <BaseSelectDropdown
          id={fieldName}
          label={component.label}
          options={component.options.map((o) => ({
            value: o.value.toString(),
            label: o.label,
            sublabel: o.sublabel ?? undefined,
          }))}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          selectProps={{
            ...field,
            value: (field.value as string) ?? (component.value as string) ?? '',
            onChange: (ev, el) => {
              field.onChange(ev, el);
              binding.sync(ev.target.value);
              binding.onBlur();
            },
            onBlur: () => {
              field.onBlur();
              binding.onBlur();
            },
          }}
        />
      )}
    />
  );
};
